module.exports = __webpack_public_path__ + "files/0c246f8e7122ef58597119409b235619.png";